import { useEffect } from 'react';
import { useSelector } from 'react-redux';

export const StateLoader = () => {
  try {
    const serializedState = sessionStorage.getItem('state');
    if (serializedState === null) {
      return undefined;
    }
    return JSON.parse(serializedState);
  } catch (err) {
    return undefined;
  }
};

export const StateSaver = (state) => {
  try {
    const serializedState = JSON.stringify(state);
    sessionStorage.setItem('state', serializedState);
  } catch {
    // Does not stop work by error causes
  }
};

export const SessionStorageGetter = (
  pageKey,
  propKey,
  cbToSetInitialValue,
  valueToListen
) => {
  const sessionStorageValue = useSelector((state) => state[pageKey][propKey]);

  useEffect(() => {
    cbToSetInitialValue(sessionStorageValue || valueToListen);
  }, [valueToListen, cbToSetInitialValue, sessionStorageValue]);
};
